<template>
  <div>
    <v-container class="pa-0" fluid>
      <component
        :serviceProp="serviceID"
        :feePlanProp="selectedFeePlan"
        :startDate="filter.fromDate"
        :endDate="filter.toDate"
        :is="isCompo"
        :enquiryID="enquiryID"
        :franchiseeID="franchiseeID"
        :academicYearID="academicYearID"
      >
      </component>
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="4" class="my-0 py-0">
            <div clasuccessss="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Assign Service
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="8">
            <v-card-actions>
              <a @click="$router.back()">
                <v-btn small v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
              </a>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-card-component>
          <form>
            <v-row v-if="studentInfo">
              <v-col cols="12" md="2" sm="4">
                <v-img :src="tots_image" width="120"></v-img>
              </v-col>
              <v-col cols="12" v-if="studentInfo.enquiryCode" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Enquiry Code
                </div>
                <div class=" mb-1 font-weight-bold" v-text="studentInfo.enquiryCode"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Name
                </div>
                <div
                  class="mb-1 font-weight-bold"
                  v-text="studentInfo.studentFirstName ? studentInfo.studentFirstName + ' ' + (studentInfo.studentLastName !== null ? studentInfo.studentLastName : '') : studentInfo.studentName"
                ></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.franchisee">
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class=" mb-1 font-weight-bold" v-text="studentInfo.serviceRegistration.franchisee.companyName || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.academicYear">
                <div class="grey--text text-subtitle-2 mb-1">
                  Academic Year
                </div>
                <div class=" mb-1 font-weight-bold" v-text="studentInfo.academicYear.academicYear || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.studentClass">
                <div class="grey--text text-subtitle-2 mb-1">
                  Class
                </div>
                <div class=" mb-1 font-weight-bold" v-text="studentInfo.studentClass.name || ''"></div>
              </v-col>

              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherName">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherName"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherMobile">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Mobile
                </div>
                <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherMobile || ''"></div>
              </v-col>
              <v-col cols="12" md="4" v-if="studentInfo.fatherEmailID">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Email
                </div>
                <div class="mb-1 font-weight-bold" v-text="studentInfo.fatherEmailID || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.gender">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <div
                  v-if="studentInfo.gender === 'Female' || studentInfo.gender === 'FEMALE'"
                  class="mb-1 font-weight-bold"
                  v-text="studentInfo && studentInfo.gender && studentInfo.gender === 'Female' ? 'Girl' : '-' || (studentInfo && studentInfo.gender && studentInfo.gender === 'FEMALE') ? 'Girl' : '-'"
                ></div>
                <div
                  v-if="studentInfo.gender === 'Male' || studentInfo.gender === 'MALE'"
                  class="mb-1 font-weight-bold"
                  v-text="studentInfo && studentInfo.gender && studentInfo.gender === 'Male' ? 'Boy' : '-' || (studentInfo && studentInfo.gender && studentInfo.gender === 'MALE') ? 'Boy' : '-'"
                ></div>
                <div v-if="studentInfo.gender === null" class="mb-1">--</div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">From </label>
                <custom-date-picker :minToDate="maxToDate" v-model="filter.fromDate" required />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">To </label>
                <custom-date-picker :minToDate="filter.fromDate" v-model="filter.toDate" required />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">
                  Service Category
                  <span class="error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  @change="getServices"
                  required
                  v-model.trim="serviceCategoryID"
                  :items="serviceCategories"
                  key="id"
                  item-value="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="3">
                <label class="font-weight-medium body-2">Select Service Type <span class="error--text">*</span></label>
                <v-autocomplete @change="getServicePlans" class="my-0 py-1" placeholder="--Select--" required v-model="serviceID" :items="servicesList" key="id" item-value="id" item-text="name">
                </v-autocomplete>
              </v-col>
            </v-row>
          </form>
          <v-divider></v-divider>
          <div v-if="servicePlanData.length > 0">
            <label class="text-overline mb-4">List of available fee plans</label>

            <div v-for="servicePlan in servicePlanData" :key="servicePlan.id">
              <v-card rounded="lg" elevation="3" class="my-4 ">
                <!-- <v-card flat> -->

                <v-row>
                  <v-col cols="12" md="4" sm="6" lg="3">
                    <v-card-subtitle class="font-weight-medium "
                      ><div class="body-1">Plan Name :</div>
                      <span class="darkblue--text"> {{ servicePlan.name ? servicePlan.name : '--' }}</span></v-card-subtitle
                    >
                  </v-col>
                  <v-col cols="12" md="4" sm="6" lg="3">
                    <v-card-subtitle class="font-weight-medium "
                      ><div class="body-1">Description :</div>
                      <span class="pink--text"> {{ servicePlan.description ? servicePlan.description : '--' }}</span></v-card-subtitle
                    >
                  </v-col>

                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium"
                      ><div class="body-2">Year :</div>
                      <span class="primary--text">
                        {{ servicePlan.franchiseeAcademicYear && servicePlan.franchiseeAcademicYear.academicYear ? servicePlan.franchiseeAcademicYear.academicYear : '-' }}</span
                      ></v-card-subtitle
                    >
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-card-subtitle class="font-weight-medium"
                      ><div class="body-2">Plan Start Date :</div>
                      <span class="primary--text"> {{ servicePlan && servicePlan.startLimitedPeriod ? new Date(servicePlan.startLimitedPeriod).toLocaleDateString() : '-' }}</span></v-card-subtitle
                    >
                  </v-col>

                  <v-col cols="12" md="3" sm="6">
                    <v-card-subtitle class="font-weight-medium"
                      ><div class="body-2">Plan End Date :</div>
                      <span class="primary--text"> {{ servicePlan && servicePlan.endLimitedPeriod ? new Date(servicePlan.endLimitedPeriod).toLocaleDateString() : '-' }}</span></v-card-subtitle
                    >
                  </v-col>
                  <v-col cols="12" md="2" sm="6">
                    <v-card-subtitle class="font-weight-medium "
                      ><div class="body-1">Amount :</div>
                      <span class="secondary--text font-weight-bold"> {{ servicePlan.amount ? servicePlan.amount : '-' }}</span></v-card-subtitle
                    >
                  </v-col>
                </v-row>
                <v-divider class="my-0"></v-divider>
                <v-row justify="end">
                  <v-col cols="12" md="4" sm="12" class="jsutiy">
                    <v-btn outlined elevation="1" color="primary" @click="assignEnquiryID(servicePlan.id)">
                      <v-icon left>mdi-arrange-bring-forward</v-icon>
                      Assign this plan
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
          <v-card-component v-else>
            <v-card-title class="d-flex justify-center">No Data</v-card-title>
          </v-card-component>
        </v-card-component>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
// import _ from 'lodash'
import ServicePlan from '../../components/services/servicePlan'
import Stores from '@/stores'

export default {
  name: 'assignServicePlan',
  props: ['enquiryID', 'isTransport'],
  components: {
    ServicePlan,
    MaterialCard,
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      studentInfo: '',
      STUDENT_DATA: {},
      search: '',
      planAssignModal: false,
      sendLinkDialogOffline: false,
      isWrite: false,
      filterData: [],
      // isService: false,
      serviceCategories: [],
      serviceCategoryID: '',

      serviceID: '',
      searchTerm: '',
      radio: 'all',
      servicesList: [],
      total: 0,
      sendLinkDialog: false,
      isLoading: false,
      loadingComponent: null,
      enableDocumentModal: false,
      enableSectionModal: false,
      enableSectionModalOffline: false,
      servicePlanData: [],
      franchiseeID: '',
      hasClicked: false,
      sectionID: '',
      classID: '',
      selectedclassID: '',
      selectedclassName: '',
      selectedEnquiryCode: '',
      academicYearID: '',
      isCompo: null,
      findEnquiry: {
        academicYearID: '',
        searchType: 'mobileNo',
        searchKey: ''
      },

      filter: {
        fromDate: moment()
          .subtract(0, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment()
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      studentPhotoURL: '',
      fatherPhotoURL: '',
      motherPhotoURL: '',
      birthCertificateURL: '',
      transferCertificateURL: '',
      immunisationCertificateURL: '',
      studentAadharCardURL: '',
      fatherAadharCardURL: '',
      motherAadharCardURL: '',
      healthCertificateURL: '',
      isDataLoaded: false,
      documentData: [],
      registrationData: [],
      classes: [],
      sections: [],
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      selectedFeePlan: ''
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getServicePlans()
    }
  },
  watch: {
    // academicYearID: async function () {
    //   if (this.academicYearID && this.serviceCategoryID && this.franchiseeID) {
    //     await this.getServices()
    //   } else {
    //     this.servicesList = []
    //   }
    // },
    serviceCategoryID: async function () {
      if (this.serviceCategoryID && this.franchiseeID) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getServicePlans()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getServicePlans()
    },
    sendLinkDialog: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    },
    sendLinkDialogOffline: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    }
  },
  async created () {
    await this.getFranchiseeID()
    await this.getServices()
    await this.onstart()
    await this.getStudentData()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    try {
      this.loadingComponent = this.$buefy.loading.open()
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      //     const currentAcademicYear = Utils.getCurrentAcademicYear()
      // let academicYear = this.academicYears.find(y => {
      //   return y.academicYear.trim() === currentAcademicYear.trim()
      // })
      // this.academicYearID = academicYear ? academicYear.id : ''
      this.loadingComponent.close()
      //   await this.getServicePlans()
      this.onFranchiseeChange()
      const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
      this.classes = studentclasses.data.rows
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    getClass (isActive) {
      return !isActive ? 'accent' : 'error'
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-danger',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getServices: async function () {
      if (this.serviceCategoryID && this.franchiseeID) {
        try {
          let { data } = await http.get(`${constants.API_URL}/api/service/type`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYearID,
              categoryID: this.serviceCategoryID,
              isActive: true
            }
          })

          this.servicesList = data.rows
          if (this.servicesList.length === 0) {
            return this.$dialog.message.error('No service type Available', {
              position: 'top',
              timeout: 4000
            })
          }
          console.log(this.servicesList, 'serviceList')
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
        }
      }
    },
    onstart: async function () {
      await this.getCategories()
    },
    getCategories: async function () {
      try {
        let payload = {}
        payload.isActive = true
        if (this.isTransport === 'false') {
          payload.type = null
        } else {
          payload.type = this.isTransport ? constants.SERVICE_TYPE.TRANSPORT : null
        }
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/service/category/type/list`, payload)
        this.serviceCategories = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    assignEnquiryID: function (id) {
      this.selectedFeePlan = id
      this.isCompo = ''
      this.$nextTick(() => {
        this.isCompo = ServicePlan
      })
    },
    getFranchiseeID: function () {
      if (this.franchisee && this.franchisee.id) {
        this.franchiseeID = this.franchisee.id
      } else {
        let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
        this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    getServicePlans: async function () {
      try {
        console.log(this.academicYear, 'this.academicYear')
        if (this.franchiseeID && this.academicYear && this.serviceID) {
          const response = await http.get(`${constants.API_URL}/api/service/plan/`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear ? this.academicYear.id : this.academicYearID,
              serviceTypeID: this.serviceID,
              isActive: true
              // this.serviceID
            }
          })
          console.log(response.data, 'Datas')

          this.servicePlanData = response.data
          if (this.servicePlanData.length < 1) {
            this.errMsg('No Plan is assigned for this Service')
          }
          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getYearIn: function () {
      this.academicYears.find(obj => {
        if (obj.id === this.filter.academicYearID) {
          this.Year = Number(obj.academicYear.split('-')[0])
        }
      })
    },
    getStudentData: async function () {
      try {
        this.isLoading = true
        // let res = await http.get(`${CONSTANTS.API_URL}/api/student/service/fee-plan/${this.enquiryID}`)
        let res = await http.get(`${constants.API_URL}/api/student/service/fee-plan`, {
          params: {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYearID,
            isRequired: false,
            enquiryID: this.enquiryID,
            startDate: this.filter.fromDate,
            endDate: this.filter.toDate
          }
        })
        this.studentInfo = res.data[0]
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    academics: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      // const currentAcademicYear = Utils.getCurrentAcademicYear()
      // let academicYear = this.academicYears.find(y => {
      //   return y.academicYear.trim() === currentAcademicYear.trim()
      // })
      // this.academicYearID = academicYear ? academicYear.id : ''
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = Stores.user.franchisee
      return obj
    }
  }
}
</script>
<style lang="css">
/* .colouredCard {
  background: #f2f2f2 !important;
} */
</style>
